export default "__VITE_ASSET__CAWcDoNv__"